import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import './App.css';
import './styles/bootstrap.css';
import { Route, Switch } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import ClientComponent from './workflow/checkout';
import GraciasConCita from './workflow/gratitude/gracias-con-cita';
import GraciasConPpto from './workflow/gratitude/gracias-con-ptto';
import GraciasConReplacementVehicle from './workflow/gratitude/gracias-con-vehiculo-sustitucion';
import GraciasSolicitudLlamada from './workflow/gratitude/gracias-solicitud-llamada';
import GraciasLoTenemos from './workflow/gratitude/gracias-lotenemos';

import {configuration} from './configuration'; 
import { redirectServer } from './utils';

/**
 * Redirect if not match router.
 * 
 * @note: Redirigiremos hacia widget, y este a la web externa del concesionario.
 */
function NotFoundRedirect(props) {
  // Por defecto usamos index.html
  let url = '/widget/index.html'
  if (configuration().redirects.widget !== undefined) url = `/widget/${configuration().redirects.widget}`

  // Determinamos si es prod o test.
  url = `${url}?env=${process.env.NODE_ENV === 'production' ? 'pro' : 'test'}&autoredirect=1`
  if (process.env.NODE_ENV === 'production') {
    // En test no redireccionamos para evitar loop
    redirectServer(url)
  }
  return <h1>Redireccionando a <a href={url}>Widget</a></h1>
}

class App extends Component {
  render() {
    const title = configuration().title ? configuration().title : 'Bubocar Client'
    const favicon = configuration().favicon ? configuration().favicon : 'favicon.ico'

    return (
      <div className="app-main">
        {/* <ClientComponent/> */}
        <Helmet
          title={title}
          link={[
            {'rel': 'shortcut icon', 
             'type': 'image/png', 
             'href': `/${favicon}`
            }
          ]}
        />

        <Switch>
          <Route path="/" exact component={ClientComponent} />
          { configuration().redirects.graciasCita ? <Route path={configuration().redirects.graciasCita} exact component={GraciasConCita} /> : null }
          { configuration().redirects.graciasPpto ? <Route path={configuration().redirects.graciasPpto} exact component={GraciasConPpto} /> : null }
          { configuration().redirects.loTenemos ? <Route path={configuration().redirects.loTenemos} exact component={GraciasLoTenemos} /> : null }
          { configuration().redirects.graciasLlamada ? <Route path={configuration().redirects.graciasLlamada} exact component={GraciasSolicitudLlamada} /> : null }
          { configuration().redirects.graciasReplacementVehicle ? <Route path={configuration().redirects.graciasReplacementVehicle} exact component={GraciasConReplacementVehicle} /> : null }
          <Route component={NotFoundRedirect} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js